import { register, CloudObject, defineProperty, defineRelation } from 'olympe';
import Unit from "./Unit";
import Report from "./Report";
import Picture from "./Picture";
import AndritzUser from "./AndritzUser";

/**
 * @extends {CloudObject}
 */
export default class Assessment extends CloudObject { /* empty */ }

// Hardcoded tags
register('01880fa8af7afe8a3eb5', Assessment);
Assessment.unitOperatingTimeProp = defineProperty('01880fa8e14ae1a57d1c');
Assessment.runnerDiametermmProp = defineProperty('01880fa90fe01a87f397');
Assessment.runnerNumBladesProp = defineProperty('01880fa939ebece1a7e5');
Assessment.generatorPowerFactroyProp = defineProperty('01880fa9652a386f035e');
Assessment.generatorVoltagekVProp = defineProperty('01880fa9c6fe43cbaebc');
Assessment.introductionProp = defineProperty('01880faa177fea578d86');
Assessment.generatorFrequencyProp = defineProperty('01880faafe36d9745170');
Assessment.pipesFlowVelValvemsProp = defineProperty('01880fab307ecf6b0563');
Assessment.titleProp = defineProperty('01880fab87d783b7d160');
Assessment.mainConditionsPowerMWProp = defineProperty('01880fac284b99531cdb');
Assessment.mainConditionsRunawaySpeedrpmProp = defineProperty('01880fac3ce4a21111ab');
Assessment.lastModifiedProp = defineProperty('01880fac5d4b9273eb04');
Assessment.mainConditionsLoadRejectionSpeedrpmProp = defineProperty('01880fac85449aa1ea8c');
Assessment.generatorPowerMWProp = defineProperty('01880fac99d677a03fae');
Assessment.pipesSuctionInletDiammmProp = defineProperty('01880facae1304902ede');
Assessment.endDateProp = defineProperty('01880faccb6cdb2fa2d8');
Assessment.mainConditionsNominalSpeedrpmProp = defineProperty('01880fad05bebcd684f3');
Assessment.mainConditionsDischargem3sProp = defineProperty('01880fad25fd441d08eb');
Assessment.generatorOutputMVAProp = defineProperty('01880fad3c35c7dc4c35');
Assessment.generatorVoltageVariationProp = defineProperty('01880fad66f6e3f44450');
Assessment.unitOperationStartProp = defineProperty('01880fad88ed79b2d120');
Assessment.creationDateProp = defineProperty('01880fada39e4103cf07');
Assessment.pipesFlowVelSpiralmsProp = defineProperty('01880fae0477d5d3d1a5');
Assessment.generatorCurrentAProp = defineProperty('01880fae1c54d1d58bde');
Assessment.pipesSphereValveDiammmProp = defineProperty('01880fae2d7702a6608c');
Assessment.deletedProp = defineProperty('01880fae50478b0dace5');
Assessment.conclusionProp = defineProperty('01880fae6de7efa7ebba');
Assessment.draftProp = defineProperty('01880faea9400d738820');
Assessment.mainConditionsHeadmProp = defineProperty('01880faeef70adb50259');
Assessment.countryProp = defineProperty('01884cea775fec760b7b');
Assessment.provinceProp = defineProperty('01884cea95e582227455');
Assessment.regionProp = defineProperty('01884ceaadb6cd11fd23');
Assessment.reportsRel = defineRelation('01880fb019cba8e051df', Assessment, Report);
Assessment.conclusionPicturesRel = defineRelation('01880fbe8b7fffcc411f', Assessment, Picture);
Assessment.introductionPicturesRel = defineRelation('01880fbea854940b3dbe', Assessment, Picture);
Assessment.creatorRel = defineRelation('01880fbf6e03fe1db12a', Assessment, AndritzUser);
Assessment.assigneeRel = defineRelation('01880fbf9186d266a48b', Assessment, AndritzUser);
Assessment.unitsRel = defineRelation('0188d02e5ffb9ed101b0', Assessment, Unit);
